import { forwardRef } from 'react'
import RcTimePicker from 'rc-time-picker'

import type { TimePickerProps } from './TimePicker'
import TimePicker from './TimePicker'

const TimePickerPerFlag = forwardRef<RcTimePicker, TimePickerProps>(
  (props, ref) => {
    return <TimePicker ref={ref} {...props} />
  }
)

export default TimePickerPerFlag
